/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

/**
 * Created by andrea on 2017-06-21.
 */

import * as moment from 'moment';

export class StageSpriteUtils {

  static formatLongDate(date: string) : string {
    return moment(date).format('MMM Do YYYY');
  }

  static getPlacement(num: number) : string {
    if (num > 0) {
      const suffix = ["th", "st", "nd", "rd"];
      const val = num % 100;
      return num + (suffix[(val - 20) % 10] || suffix[val] || suffix[0]);
    } else {
      return null;
    }
  }

  static formatDateTimeIgnoreTimeZone(time: string) : string {
    return moment.utc(time).format('MMM Do YYYY h:mm a');
  }
}



// WEBPACK FOOTER //
// ./src/shared/StageSpriteUtils.ts